import { Box, Grid, Typography } from "@mui/material";
import React, { useCallback, useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import PurchaseRequestTable from "../../../components/Table/DocumentTable/PurchaseRequestTable";
import { getAllPurchaseRequestExport } from "../../../features/Purchase/PurchaseRequest/purchase-request-actions";
import { useSnackbar } from "notistack";
import { purchaseRequestActions } from "../../../features/Purchase/PurchaseRequest/purchase-request-slice";
import { CustomizedBox } from "../../../components/Custom/CustomizedBox";
import moment from "moment";
import { useForm } from "react-hook-form";
import NewReportDateFilter from "../../../components/UI/newReportDateFilter";
import { dateToUnix } from "../../../utils/date-converter";
import { exportCSVParams } from "../../../utils/filterparams";

const RequestReport = () => {
  const { allPurchaseRequestExport, isLoading } = useSelector(
    (state) => state.purchaseRequest
  );
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const gridRef = useRef();

  const breadcrumbs = [
    {
      name: t("purchase.index"),
      to: "/purchase",
    },
    {
      name: t("purchase.report.index"),
      to: "/purchase/report",
    },
    {
      name: t("purchase.report.request.index"),
    },
  ];

  const { control, getValues, reset, setValue } = useForm({
    defaultValues: {
      dateType: "lastWeek",
      date: new Date(moment().startOf("day").subtract(7, "day")),
      dateTo: new Date(moment().endOf("day")),
    },
  });

  useEffect(() => {
    dispatch(
      getAllPurchaseRequestExport(
        {
          startRow: 0,
          endRow: Math.pow(10, 10),
          filterModel: {
            issue_date: {
              filter: parseInt(
                dateToUnix(new Date(moment().startOf("day").subtract(7, "day")))
              ),
              filterTo: parseInt(dateToUnix(new Date(moment().endOf("day")))),
              filterType: "number",
              type: "inRange",
            },
          },
          sortModel: [],
        },
        enqueueSnackbar
      )
    );

    return () => {
      dispatch(purchaseRequestActions.resetAllPurchaseRequest());
    };
  }, [enqueueSnackbar, dispatch]);

  const onBtnExport = useCallback(async () => {
    let startDate = getValues("date");
    let endDate = getValues("dateTo");
    const params = exportCSVParams(
      t("purchase.request.index"),
      startDate,
      endDate
    );
    gridRef.current.api.exportDataAsCsv(params);
    enqueueSnackbar("นำออกใบขอซื้อสำเร็จ", {
      variant: "success",
    });
  }, [enqueueSnackbar, getValues, t]);

  const onFilterReset = () => {
    if (gridRef) {
      gridRef.current.api.setFilterModel({});
    }
    reset();
    dispatch(
      getAllPurchaseRequestExport(
        {
          startRow: 0,
          endRow: Math.pow(10, 10),
          filterModel: {
            issue_date: {
              filter: parseInt(
                dateToUnix(new Date(moment().startOf("day").subtract(7, "day")))
              ),
              filterTo: parseInt(dateToUnix(new Date(moment().endOf("day")))),
              filterType: "number",
              type: "inRange",
            },
          },
          sortModel: [],
        },
        enqueueSnackbar
      )
    );
  };

  const getFilteredPurchaseRequest = useCallback(() => {
    let startDate = getValues("date");
    let endDate = getValues("dateTo");

    dispatch(
      getAllPurchaseRequestExport(
        {
          startRow: 0,
          endRow: Math.pow(10, 10),
          filterModel: {
            issue_date: {
              filter: parseInt(dateToUnix(startDate)),
              filterTo: parseInt(dateToUnix(endDate)),
              filterType: "number",
              type: "inRange",
            },
          },
          sortModel: [],
        },
        enqueueSnackbar
      )
    );
  }, [dispatch, enqueueSnackbar, getValues]);

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">
          {t("purchase.report.request.index")}
        </Typography>
        <CustomizedButton
          title="นำออกข้อมูล"
          variant="contained"
          onClick={onBtnExport}
        />
      </Box>
      <CustomizedBox>
        <Typography ml={1} mb={2} fontWeight="bold">
          ตัวกรองแสดงผล
        </Typography>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <NewReportDateFilter
                t={t}
                control={control}
                setValue={setValue}
                getValues={getValues}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} alignSelf="center">
              <CustomizedButton
                title={t("button.submitFilter")}
                variant="contained"
                onClick={getFilteredPurchaseRequest}
                disabled={isLoading.allPurchaseRequest}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} alignSelf="center">
              <CustomizedButton
                title={t("button.resetFilter")}
                variant="outlined"
                onClick={onFilterReset}
                disabled={isLoading.allPurchaseRequest}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
      </CustomizedBox>
      <PurchaseRequestTable
        gridRef={gridRef}
        rowData={allPurchaseRequestExport}
        isReport
      />
    </>
  );
};

export default RequestReport;
